import { DEG_TO_RAD } from './constants';

export default function deg(radians) {
    return radians / DEG_TO_RAD;
}


// WEBPACK FOOTER //
// ./node_modules/@progress/kendo-drawing/dist/es/util/deg.js